import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiRolesList } from '@/entities/roles/modules/api/roles';

export const useRolesList = () =>
  useFetch({
    api: apiRolesList,
    keywords: queryKeys.roles.list,
    staleTime: 60_000,
  });
